import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=0f7ffa04&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=ts"
export * from "./SimpleTable.vue?vue&type=script&lang=ts"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=0f7ffa04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ffa04",
  null
  
)

export default component.exports